import { trpc } from 'api/trpc'
import { useDebounce } from 'use-debounce'

const useInventoryTrace = ({
  id,
  code,
  inventory,
  enabled,
}: {
  id: string | number
  code: string
  inventory?: string
  enabled: boolean
}) => {
  const [inventoryDebounced] = useDebounce(inventory?.toUpperCase(), 1000)
  const trace = trpc.frames.trace.useQuery(
    {
      id: Number(id),
      code: code,
      inventory_no: inventoryDebounced || '',
    },
    {
      enabled: !!inventoryDebounced && !!enabled,
    }
  )

  return trace
}

export default useInventoryTrace
